import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=dfc7183c&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=dfc7183c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc7183c",
  null
  
)

export default component.exports